import React from "react";
import { ReactComponent as CalendarIcn } from "../../assets/images/calendarIcn.svg";

const CalendarIcon = ({ size }) => {
  const getDimensions = () => {
    switch (size) {
      case "small":
        return { width: 20, height: 19 };
      case "medium":
        return { width: 22, height: 21 };
      case "large":
        return { width: 24, height: 23 };
      default:
        return { width: 26, height: 25 };
    }
  };

  const { width, height } = getDimensions();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 15 15" fill="none">
      <path
        d="M15 3V4H0V3C0 1.79 0.86 0.78 2 0.55V1C2 1.275 2.225 1.5 2.5 1.5C2.775 1.5 3 1.275 3 1V0.5H4.5V1C4.5 1.275 4.725 1.5 5 1.5C5.275 1.5 5.5 1.275 5.5 1V0.5H7V1C7 1.275 7.225 1.5 7.5 1.5C7.775 1.5 8 1.275 8 1V0.5H9.5V1C9.5 1.275 9.725 1.5 10 1.5C10.275 1.5 10.5 1.275 10.5 1V0.5H12V1C12 1.275 12.225 1.5 12.5 1.5C12.775 1.5 13 1.275 13 1V0.55C14.14 0.78 15 1.79 15 3ZM7.5 0C7.225 0 7 0.225 7 0.5H8C8 0.225 7.775 0 7.5 0ZM2.5 0C2.225 0 2 0.225 2 0.5V0.55C2.16 0.515 2.33 0.5 2.5 0.5H3C3 0.225 2.775 0 2.5 0ZM5 0C4.725 0 4.5 0.225 4.5 0.5H5.5C5.5 0.225 5.275 0 5 0ZM10 0C9.725 0 9.5 0.225 9.5 0.5H10.5C10.5 0.225 10.275 0 10 0ZM12.5 0C12.225 0 12 0.225 12 0.5H12.5C12.67 0.5 12.84 0.515 13 0.55V0.5C13 0.225 12.775 0 12.5 0ZM15 11.5C15 13.435 13.435 15 11.5 15C9.565 15 8 13.435 8 11.5C8 9.565 9.565 8 11.5 8C13.435 8 15 9.565 15 11.5ZM13 11.5C13 11.225 12.775 11 12.5 11H12V10C12 9.725 11.775 9.5 11.5 9.5C11.225 9.5 11 9.725 11 10V11.5C11 11.775 11.225 12 11.5 12H12.5C12.775 12 13 11.775 13 11.5ZM15 5V8.68C14.175 7.655 12.915 7 11.5 7C9.02 7 7 9.02 7 11.5C7 12.915 7.655 14.175 8.68 15H2.5C1.12 15 0 13.88 0 12.5V5H15ZM3.5 12.5C3.5 12.225 3.275 12 3 12C2.725 12 2.5 12.225 2.5 12.5C2.5 12.775 2.725 13 3 13C3.275 13 3.5 12.775 3.5 12.5ZM3.5 10C3.5 9.725 3.275 9.5 3 9.5C2.725 9.5 2.5 9.725 2.5 10C2.5 10.275 2.725 10.5 3 10.5C3.275 10.5 3.5 10.275 3.5 10ZM3.5 7.5C3.5 7.225 3.275 7 3 7C2.725 7 2.5 7.225 2.5 7.5C2.5 7.775 2.725 8 3 8C3.275 8 3.5 7.775 3.5 7.5ZM6.5 12.5C6.5 12.225 6.275 12 6 12C5.725 12 5.5 12.225 5.5 12.5C5.5 12.775 5.725 13 6 13C6.275 13 6.5 12.775 6.5 12.5ZM6.5 10C6.5 9.725 6.275 9.5 6 9.5C5.725 9.5 5.5 9.725 5.5 10C5.5 10.275 5.725 10.5 6 10.5C6.275 10.5 6.5 10.275 6.5 10ZM6.5 7.5C6.5 7.225 6.275 7 6 7C5.725 7 5.5 7.225 5.5 7.5C5.5 7.775 5.725 8 6 8C6.275 8 6.5 7.775 6.5 7.5Z"
        fill="#8E8E8E"
      />
    </svg>
  );
};

export default CalendarIcon;
